import { render, staticRenderFns } from "./ExternalReferenceModalForm.vue?vue&type=template&id=61a98ae8"
import script from "./ExternalReferenceModalForm.vue?vue&type=script&lang=js"
export * from "./ExternalReferenceModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports